export const hi_HI = {
    "PREFIX": {
        "QUESTION": "प्रश्न",
        "QUESTION-PART": "रश्न",
        "PRE-RELEASE": "Pre Release",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "अंक"
    }
};

